import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTreeModule } from '@angular/material/tree';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatCardModule } from '@angular/material/card';
import {  MatRadioModule } from '@angular/material/radio';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';



@NgModule({
    imports: [
        MatFormFieldModule,
        MatSlideToggleModule,
        MatIconModule,
 
        MatSelectModule,
        MatDividerModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatInputModule,
        MatButtonModule,
        MatTableModule,
        MatExpansionModule,
        MatDialogModule,
        MatTreeModule,
        MatAutocompleteModule,
        MatCardModule,
        MatRadioModule,
        MatTooltipModule,
        MatListModule,
        MatDatepickerModule,
        MatTabsModule
        
    ],
    exports: [
        MatSelectModule,
        MatFormFieldModule,
        MatSlideToggleModule,
        MatIconModule,
        MatDividerModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatInputModule,
        MatButtonModule,
        MatTableModule,
        MatExpansionModule,
        MatDialogModule,
        MatTreeModule,
        MatAutocompleteModule,
        MatCardModule,
        MatRadioModule,
        MatTooltipModule,
        MatListModule,
        MatDatepickerModule,
        MatTabsModule
    ]
})
export class MaterialModule { }
